module.exports = __webpack_public_path__ + "img/teal-half-moon-angle.06ceeb8.svg";